import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { ReportCategories } from '../../../../common/enums/reportCategories';
import { ServiceType } from '../../../../common/enums/serviceType';
import { fetchJson } from '../../../store/fetch';
import { Button } from '../common';
import { getStartProcedureOrConsultButtonText } from './getStartProcedureOrConsultButtonText';

interface IAcceptAndStartProcedureOrConsultButtonProps {
    addProcedure?: () => Promise<void>;
    addReport?: (reportCategory: ReportCategories.consultReport) => Promise<void>;
    reloadProcess: () => Promise<void>;
    request: IRequestGetOne;
}

export function AcceptAndStartProcedureOrConsultButton(props: IAcceptAndStartProcedureOrConsultButtonProps) {
    if (!props.request.authorization || !props.request.authorization.canUpdateRequestToAccepted) {
        return null;
    }

    return (
        <Button
            automation="addReport"
            color="secondary"
            large
            onClick={async () => {
                const url = `/api/requests/${props.request.id}/accept`;
                await fetchJson(url, 'POST');
                await props.reloadProcess();
                if (props.request.serviceType === ServiceType.consultation && props.addReport) {
                    await props.addReport(ReportCategories.consultReport);
                }
                if (props.request.serviceType === ServiceType.examination && props.addProcedure) {
                    await props.addProcedure();
                }
            }}
        >
            {getStartProcedureOrConsultButtonText(props.request)}
        </Button>
    );
}
